/**
 * Pulse film section — scroll-triggered play/pause.
 * Ported from Film() in storefront/app/routes/preview.home.tsx.
 *
 * The poster paints first (native <video poster>); the source video only
 * switches to preload="auto" and starts playing once the element is at
 * least 35% visible, and pauses again when it scrolls out. Costs nothing on
 * landing.
 */
(function () {
  if (window.__pulse_film) return;
  window.__pulse_film = true;

  function initFilm(video) {
    if (typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
            if (video.preload === 'none') video.preload = 'auto';
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      },
      {threshold: 0.35},
    );
    io.observe(video);
  }

  function init() {
    var video = document.getElementById('pulse-film-video');
    if (video) initFilm(video);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var video = e.target.querySelector('#pulse-film-video');
    if (video) initFilm(video);
  });
})();
